import { Button, Icon, Popover } from '@sgme/ui';
import { DocumentError } from 'apiConnector/document/document';
import { MultiLanguageDocumentErrorContent } from 'components/shared/Document/MultiLanguageDocumentError';
import { ErrorDisplayContext } from 'components/shared/Document/MultiLanguageDocumentItem';
import { useState } from 'react';

export function EssentialErrorDoc({
  error,
  errorContext,
  initOpen = false,
}: {
  error: DocumentError;
  errorContext?: ErrorDisplayContext;
  initOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(initOpen);

  return (
    <Popover
      color="danger"
      maxWidth={620}
      style={{ padding: 0 }}
      placement="top"
      contents={
        <MultiLanguageDocumentErrorContent error={error} errorContext={errorContext} onClose={() => setIsOpen(false)} />
      }
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Button iconPosition="icon-only" purpose="link">
        <Icon size="sm" icon="block" className="m-0 text-danger" />
      </Button>
    </Popover>
  );
}
